import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useAdmin } from '../../contexts/AdminContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { canAccessRoute, getDefaultRoute, loading: adminLoading } = useAdmin();
  const location = useLocation();

  // Show loading while checking auth or admin context
  if (authLoading || adminLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: 'background.default',
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check route authorization
  if (!canAccessRoute(location.pathname)) {
    return <Navigate to={getDefaultRoute()} replace />;
  }

  return children;
};

export default ProtectedRoute;
